export default __webpack_public_path__ + "static/media/puppy.255ba8ac.png";